<template>
  <HomePage />
</template>